import React, { createContext, useContext, useMemo, useState, useCallback } from "react";
import { X } from "lucide-react";

const ToastCtx = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((toast) => {
    const id = crypto?.randomUUID?.() || String(Date.now());
    const item = { id, type: "success", title: "Success", message: "", ...toast };
    setToasts((t) => [item, ...t].slice(0, 3));
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 2800);
  }, []);

  const api = useMemo(() => ({ push }), [push]);

  return (
    <ToastCtx.Provider value={api}>
      {children}
      <div className="fixed right-4 top-4 z-50 space-y-3">
        {toasts.map((t) => (
          <div
            key={t.id}
            className="w-[320px] rounded-2xl border border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-lg p-4"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-semibold text-gray-900 dark:text-slate-100">{t.title}</div>
                <div className="text-sm text-gray-600 dark:text-slate-400 mt-1">{t.message}</div>
              </div>
              <button
                onClick={() => setToasts((x) => x.filter((y) => y.id !== t.id))}
                className="p-1 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-800"
                aria-label="Close toast"
              >
                <X className="h-4 w-4 text-gray-500 dark:text-slate-500" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
};
